import { render, staticRenderFns } from "./PillCell.vue?vue&type=template&id=645483f6"
import script from "./PillCell.vue?vue&type=script&lang=js"
export * from "./PillCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports